import React, { useContext } from 'react';
import { AuthorizationContext } from 'src/contexts/authorizationContext';
import routes from 'src/constants/routes';
import Logo from 'src/components/Logo';
import Text from 'src/components/Text';
import Link from 'src/components/Link';
import PublicMenu from './PublicMenu';
import PrivateMenu from './PrivateMenu';
import styles from './styles.module.scss';

type Props = {
  showTitle?: boolean;
  showMenu?: boolean;
};

const Header: React.FC<Props> = ({ showTitle, showMenu }) => {
  const authorizationState = useContext(AuthorizationContext);

  return (
    <header className={styles['header']}>
      <div className={styles['container']}>
        <Link to={authorizationState ? routes.agent : routes.main} className={styles['logo-link']}>
          <Logo />
          {showTitle && <Text type="logo" className={styles['title']}>Агент 1С:СБП</Text>}
        </Link>
        {showMenu && (
          <div className={styles['menu']}>
            {authorizationState ? <PrivateMenu /> : <PublicMenu />}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
